export default __webpack_public_path__ + "static/media/play-store-link.37b44cee.png";